import { useNavigate } from 'react-router-dom'

import { Alert, Box, Card, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { countryName } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

import { ChargebeeSubscriptionForm } from 'modules/billing/components/PaymentGateway/FullScreenStep/form'
import { FORBIDDEN_COUNTRIES } from 'modules/billing/components/PaymentGateway/FullScreenStep/helpers'

import FormBody from './_Body'

interface Props {
  form: ChargebeeSubscriptionForm
}

const BillingInfoSection = ({ form }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { company } = useCurrentSession()
  const mainLegalEntity = company.legalEntities.find((le) => le.main)
  const isForbiddenCountry = FORBIDDEN_COUNTRIES.includes(
    mainLegalEntity?.country.toLowerCase() ?? ''
  )

  const ForbiddenCountryAlert = () => {
    return (
      <Box gap="s16">
        <Alert color="error">
          <Text.Normal color="radicalRed1500">
            {i18n.t('pricing_plans.billing_information.form.forbidden_country_message')}
          </Text.Normal>
        </Alert>
      </Box>
    )
  }

  return (
    <Box gap="s16">
      <Text.Header2 weight="semibold">
        {i18n.t('pricing_plans.billing_information.form.billing_title')}
      </Text.Header2>
      <Card>
        <Card.Content>
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween" width="full">
            <Text.Normal weight="medium" color="grey1000">
              {countryName(mainLegalEntity?.country)}
            </Text.Normal>
            <Box
              cursor="pointer"
              onClick={() =>
                navigate(
                  navigation.settings.legalEntitiesId.fullPath({ id: mainLegalEntity?.id ?? '' })
                )
              }
            >
              <Text.Normal size="200" color="viridian1200">
                {i18n.t('pricing_plans.billing_information.form.change_country')}
              </Text.Normal>
            </Box>
          </Box>
        </Card.Content>
      </Card>
      {isForbiddenCountry ? (
        <ForbiddenCountryAlert />
      ) : (
        <FormBody form={form} country={mainLegalEntity?.country ?? ''} />
      )}
    </Box>
  )
}

export default BillingInfoSection
